/**
 * Vetbot cross-promo UI state — one-time success modal after claim/creation.
 * Mirrors the localStorage pattern in useOnboardingTour.ts.
 */
const SUCCESS_KEY = 'vetbot-success-seen'

export function useVetbotPromo() {
  function hasSeenSuccessModal(): boolean {
    if (!import.meta.client) return true
    return localStorage.getItem(SUCCESS_KEY) === 'true'
  }

  function markSuccessModalSeen() {
    if (import.meta.client) {
      localStorage.setItem(SUCCESS_KEY, 'true')
    }
  }

  return {
    hasSeenSuccessModal,
    markSuccessModalSeen,
  }
}
